export const STRUCTURED_COMMENT_MULTI_BLOCK_CLASS = 'structuredCommentMultiBlock';
